/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserVerificationRequest
 */
export interface UserVerificationRequest {
    /**
     * 
     * @type {string}
     * @memberof UserVerificationRequest
     */
    code: string;
}

/**
 * Check if a given object implements the UserVerificationRequest interface.
 */
// @ts-ignore
export function instanceOfUserVerificationRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;

    return isInstance;
}

// @ts-ignore
export function UserVerificationRequestFromJSON(json: any): UserVerificationRequest {
    return UserVerificationRequestFromJSONTyped(json, false);
}

// @ts-ignore
export function UserVerificationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserVerificationRequest {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
    };
}

// @ts-ignore
export function UserVerificationRequestToJSON(value?: UserVerificationRequest | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
    };
}

